import * as d3 from "d3";
import { LegendBackground } from "../../interfaces/map.interfaces";

export default class Legend {
  #container: any;
  #selectionCallback!: Function;
  #backgrounds: LegendBackground = {
    blues:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAABCAYAAAAxWXB3AAAAAXNSR0IArs4c6QAAAKxJREFUOE+tk9sOgDAIQ+v//zMY1rEhYDTRp3lhZT1lh4ioAlBV2ENcAYXwJ0aVgmuuL/unFmwNulYnajLpO2u6Pt536Kx98ayNnvu46cMzbT+uW/099Hnw432cq3HLHIWAF+erz8zJ3wPflifrtp+YY+AczlNymowok3K85ct8y9xk32X/Oz97Pvv5KnzXvH6YF2n8z7lafMO9YL7/+BkkQ759nsy5nZsX9/IE0s8xwkXry3AAAAAASUVORK5CYII=",
    reds: "data:image/png;base64,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",
  };
  #img;

  #sequentialG;
  #ordinalDiv;
  #axis: any;
  #axisScale: any;

  constructor(container: any) {
    this.#container = container;
    this.#img = d3.select(container).select("img");
    const svg = d3.select(container).select(".legendCanvas");
    this.#sequentialG = svg.append("g").style("font-size", "16px");
    this.#ordinalDiv = d3
      .select(container)
      .append("div")
      .attr("class", "ordinalLegend");
    // @ts-ignore
    this.#axis = d3.axisBottom();
  }

  setSequentialColorScale(scheme: string, scale: any, inverted: boolean) {
    const that = this;
    const bbox = d3.select(that.#container).node().getBoundingClientRect();
    that.#sequentialG.attr("transform", `translate(0, ${bbox.height * 0.5} )`);
    that.#ordinalDiv.style("display", "none");
    that.#sequentialG.style("display", "block").style("opacity", 1);
    that.#img.style("display", "block").style("opacity", 1);

    that.#axisScale = d3
      .scaleLinear()
      .domain(scale.domain())
      .range([0, bbox.width]);

    that.#img.attr("src", that.#backgrounds[scheme]);

    // @ts-ignore
    const locale = d3.formatLocale({
      decimal: ".",
      thousands: "'",
      grouping: [3],
    });
    const format = locale.format(",");
    // @ts-ignore
    that.#axis = this.#axis.scale(that.#axisScale).ticks(5).tickFormat(format);

    that.#sequentialG.selectAll(".tick").remove();
    that.#sequentialG.call(that.#axis);

    that.#sequentialG.select(".tick:first-child").remove();
    that.#sequentialG.select(".tick text").text((d: any) => "<= " + format(d));
    that.#sequentialG.select(".tick:last-child").remove();
    that.#sequentialG
      .select(".tick:last-child text")
      .text((d: any) => `>= ${format(d)}`);
    var lowerPart =
      scale.domain()[0] + (scale.domain()[1] - scale.domain()[0]) * 0.4;
    if (!inverted) {
      that.#sequentialG
        .selectAll(".tick text")
        .attr("fill", (d: any) => (d < lowerPart ? "black" : "white"));
      that.#sequentialG
        .selectAll(".tick line")
        .attr("stroke", (d: any) => (d < lowerPart ? "black" : "white"));
    } else {
      that.#sequentialG
        .selectAll(".tick text")
        .attr("fill", (d: any) => (d < lowerPart ? "white" : "black"));
      that.#sequentialG
        .selectAll(".tick line")
        .attr("stroke", (d: any) => (d < lowerPart ? "white" : "black"));
      that.#img.style("transform", "scaleX(-1)");
    }
  }

  setDivergingColorScale(scheme: any, scale: any) {
    const that = this;
    const bbox = d3.select(that.#container).node().getBoundingClientRect();
    //Hide image
    this.#img.style("display", "none");
    that.#sequentialG.attr("transform", `translate(0, ${bbox.height * 0.5})`);
    that.#ordinalDiv.style("display", "none");
    that.#sequentialG.style("display", "block").style("opacity", 1);
    that.#img.style("display", "block").style("opacity", 1);
    that.#axisScale = d3
      .scaleLinear()
      .domain([scale.domain()[0], scale.domain()[2]])
      .range([0, bbox.width]);

    that.#img.attr("src", scheme);

    that.#axis = that.#axis.scale(that.#axisScale).ticks(5);
    that.#sequentialG.selectAll(".tick").remove();
    that.#sequentialG.call(that.#axis);
    that.#sequentialG.select(".tick:first-child").remove();
    that.#sequentialG.select(".tick:last-child").remove();
    that.#sequentialG.select(".tick:last-child text").text((d) => `>= ${d}`);
  }

  setOrdinalColorScale(scale: any, meta: any) {
    const that = this;
    const bbox = d3.select(that.#container).node().getBoundingClientRect();
    that.#sequentialG.style("display", "none");
    that.#img.style("display", "none");
    that.#ordinalDiv.style("display", "block").style("opacity", 1.0);
    var enterfunc;
    if (meta.ordinaltranslations && meta.ordinaltranslations.length > 0) {
      enterfunc = (enter: any) => {
        return enter
          .append("div")
          .attr("class", "ordinalLabel")
          .html(
            (_: any, i: any) => "<span></span>" + meta.ordinaltranslations[i]
          );
      };
    } else {
      //i.e., no translation from codes to well readable labels
      enterfunc = (enter: any) => {
        return enter
          .append("div")
          .attr("class", "ordinalLabel")
          .html((d: any) => "<span></span>" + d);
      };
    }
    that.#ordinalDiv.selectAll("div").remove();
    const domain = scale.domain();
    that.#ordinalDiv
      .selectAll("div")
      .data(domain)
      .join(enterfunc)
      .style("background-color", (d) => scale(d))
      .style("width", `calc(100% / ${domain.length})`)
      .style("margin-top", bbox.height / 2 + "px")
      .on("click", (event, d) => {
        if (that.#selectionCallback) that.#selectionCallback(event, d);
      });
  }

  setSelectionCallback(cb: Function) {
    this.#selectionCallback = function (event: any, d: any) {
      const className = "deselectedCategory";
      const isDeselect = !d3.select(event.target).classed(className);
      d3.select(event.target).classed(className, isDeselect);
      cb(d, isDeselect);
    };
  }

  hide() {
    const that = this;
    that.#img.style("opacity", 0);
    that.#ordinalDiv.style("opacity", 0);
    that.#sequentialG.style("opacity", 0);
  }
}
